import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ReferrersPage } from '@/pages/referrers';
import { referrersSearchSchema } from '@/routes/-shared/referrersSearchSchema';
import { requireSuperadmin } from '@/routes/-shared/require-superadmin';

/**
 * La lista resta montata e i pannelli del referrer si aprono sopra di lei
 * sull'`Outlet` (`$id`, `new`, `edit/$id`). Solo i SUPERADMIN gestiscono i
 * referrer (le API rispondono 403 a SYSTEM, REF-1): il controllo sta sul
 * layout, così vale anche per le rotte figlie aperte da un link.
 */
export const Route = createFileRoute('/admin/_layout/referrers/_layout')({
  beforeLoad: requireSuperadmin,
  component: ReferrersLayout,
  validateSearch: referrersSearchSchema,
});

function ReferrersLayout() {
  return (
    <>
      <ReferrersPage />
      <Outlet />
    </>
  );
}
